import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import Stack, { Row, StackProps } from "@rui/Stack";

export const Card = styled((props: StackProps) => (
  <Stack spacing={1} {...props} />
))(({ theme }) => ({
  borderRadius: "6px",
  border: `1px solid ${theme.palette.shades.neutral[100]}`,
  padding: theme.spacing(1.5),
}));

export const Timestamp = styled((props: TypographyProps) => (
  <Typography variant="caption" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  fontFamily: theme.typography.fontFamilySecondary,
}));

export const Block = styled(Row)(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[300],
  borderRadius: "8px",
  padding: theme.spacing(1),
  color: theme.palette.shades.neutral[700],
}));

export const BlockQuote = styled(Stack)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.shades.neutral[100]}`,
  paddingLeft: "6px",
}));

export const MetricLabel = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryMed" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[700],
}));

export const MetricValue = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[700],
}));

type MetricTrendProps = StackProps & {
  type: "positive" | "negative" | "neutral";
};

export const ImpactChip = styled(
  (props: MetricTrendProps) => <Row variant="center" {...props} />,
  { shouldForwardProp: (prop) => prop !== "type" }
)(({ theme, type }) => ({
  backgroundColor:
    type === "positive"
      ? theme.palette.shades.meadow[50]
      : type === "negative"
        ? theme.palette.shades.negative[50]
        : theme.palette.shades.neutral[50],
  color:
    type === "positive"
      ? theme.palette.shades.meadow[600]
      : type === "negative"
        ? theme.palette.shades.negative[600]
        : theme.palette.shades.neutral[600],
  fontWeight: 500,
  padding: "0 2px",
  fontSize: "0.875rem",
  borderRadius: "2px",
  "& svg": {
    marginRight: "4px",
    color:
      type === "positive"
        ? theme.palette.shades.meadow[600]
        : type === "negative"
          ? theme.palette.shades.negative[600]
          : theme.palette.shades.neutral[600],
    height: "12px",
    width: "12px",
  },
}));
